{
  "version": 1,
  "asset_id": "7dca131a-393c-4372-831f-93bfb0260006",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/7dca131a-393c-4372-831f-93bfb0260006/loc-dallas-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/7dca131a-393c-4372-831f-93bfb0260006/loc-dallas-640.webp",
  "original_filename": "loc-dallas-640.webp",
  "size": 27764,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:20Z"
}
